import BaseComponent from './base-component';
const span = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'span' }, ...children);
const div = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'div' }, ...children);
const h1 = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'h1' }, ...children);
const input = (properties) => new BaseComponent({ ...properties, elementTag: 'input' });
const a = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'a' }, ...children);
const label = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'label' }, ...children);
const img = (properties) => new BaseComponent({ ...properties, elementTag: 'img' });
const button = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'button' }, ...children);
const details = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'details' }, ...children);
const summary = (properties) => new BaseComponent({ ...properties, elementTag: 'summary' });
const ul = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'ul' }, ...children);
const li = (properties, ...children) => new BaseComponent({ ...properties, elementTag: 'li' }, ...children);
const textarea = (properties) => new BaseComponent({ ...properties, elementTag: 'textarea' });
export default {
    span,
    div,
    h1,
    input,
    label,
    a,
    img,
    button,
    details,
    summary,
    ul,
    li,
    textarea,
};
